export var WebClientSize = /*#__PURE__*/ function(WebClientSize) {
    WebClientSize["WEB_CLIENT_SIZE_UNKNOWN"] = "WEB_CLIENT_SIZE_UNKNOWN";
    WebClientSize["MOBILE"] = "MOBILE";
    WebClientSize["TABLET"] = "TABLET";
    WebClientSize["DESKTOP"] = "DESKTOP";
    WebClientSize["XLARGE_DESKTOP"] = "XLARGE_DESKTOP";
    return WebClientSize;
}({});
